import { theme } from "../../config/theme";

const styles = {
  accordion: {
    width: "100%",
    minWidth: "324px",
    maxWidth: "1080px"
  },
  heading: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    marginRight: "16px"
  },
  primaryHeading: {
    color: theme.palette.primary.black,
    fontSize: "16px",
    fontWeight: "600"
  },
  secondaryHeading: {
    color: theme.palette.primary.darkGray,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "14px"
  },
  accordionContent: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center"
  }
};

export { styles };
